import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { TabProvider } from './components/TabContext';

    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
        <React.StrictMode>
            <TabProvider>
                <App />
            </TabProvider>
        </React.StrictMode>
    );


// Measure performance
reportWebVitals();

// Helper: convert VAPID key
function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

// Helper: send subscription to backend
async function sendSubscriptionToBackend(subscription) {
    try {
        await fetch('/api/save-subscription', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(subscription)
        });
        console.log("Subscription sent to backend");
    } catch (err) {
        console.error("Failed to send subscription:", err);
    }
}

// Register service worker for PWA functionality
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js')
            .then(async registration => {
                console.log('Service Worker registered:', registration);


                // Listen for controller change
                if (!navigator.serviceWorker.controller) {
                    navigator.serviceWorker.addEventListener('controllerchange', () => {
                        console.log('Service Worker now controlling the page');
                    });
                }

            })
            .catch(error => {
                console.error('Service Worker registration failed:', error);
            });
    });
}
